import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { styled } from '@this/constants/themes';
import { observer } from 'mobx-react';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Utils from '@this/domain/appoint/utils';
import { H2, ButtonWrapper, ButtonProgress } from '@this/components/appoint/common';

const InquiriesNew = observer(() => {
  const [text, setText] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [succeeded, setSucceeded] = useState<boolean>(false);

  // マウント時に1回発動
  useEffect(() => {
    Utils.trackEvent('[cal][view] inquiries new');
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage(null);
    try {
      const args = {
        text
      };
      await axios.post<Response>('/aicalendar/inquiries.json', args);
      setSucceeded(true);
    } catch (e) {
      setErrorMessage('通信エラーが発生しました。時間をおいて再度お試しください。');
    }
    setIsSubmitting(false);
  };

  return (
    <Container maxWidth="sm" style={{ minHeight: 'calc(100vh - 64px - 40px - 64px)' }}>
      <H2>フィードバック</H2>
      <Paper style={{ padding: '24px' }}>
        {succeeded ? (
          <Typography>
            貴重なフィードバックをいただきありがとうございます。
            <br />
            今後の改善につなげて参ります。
          </Typography>
        ) : (
          <>
            <Typography style={{ marginBottom: '24px' }}>
              AIカレンダーは日々改善を続けています。
              <br />
              よりよいプロダクトに成長させていくために、忌憚なきご意見をお寄せください。
            </Typography>
            <form onSubmit={e => handleSubmit(e)}>
              <TheTextField
                variant="outlined"
                label="内容"
                value={text}
                multiline
                rows={4}
                onChange={e => setText(e.target.value)}
              />
              {errorMessage && <Error>{errorMessage}</Error>}
              <ButtonWrapper style={{ margin: '0 auto' }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting || text.length === 0}
                >
                  送信
                </Button>
                {isSubmitting && <ButtonProgress />}
              </ButtonWrapper>
            </form>
          </>
        )}
      </Paper>
    </Container>
  );
});

const TheTextField = styled(TextField)`
  width: 100%;
  margin-bottom: 24px;
`;

const Error = styled(Typography).attrs(() => ({ color: 'error' }))`
  margin-bottom: 24px;
`;

export default InquiriesNew;
